const Dropdown = function ()
{

    const selectDrop = function (el) 
    {
        
        let selectedOpt = el.text();

        el.closest('ul').find('li').removeClass('selected');
        el.addClass('selected');
        el.closest('.custom-drop-filter').find('.cd-selected p').text(selectedOpt);

    }

    return {
        init: function () {

            $(".custom-drop-filter ul li").on("click", function() {
                selectDrop( $(this) );
            });
        }
    }

}();
module.exports = Dropdown;